import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// images
import buildingEducationImageDesktopWebp from './images/education-desktop.webp';
import buildingEducationImageMobileWebp from './images/education-mobile.webp';
// base urls
import { nmFoundationBaseUrl } from '../../../../../utils/unsecuredLinks';

export default () => (
  <InformationalModule
    // configs
    sectionId='sustainability-impact-communities-building-education'
    themeType='lightTheme'
    backgroundVariant='lightA'
    moduleName='financial-planning-module'
    moduleVariation='A'
    reverseContent={false}
    // content
    subHeadingText={<>Building education and opportunity pathways from early childhood</>}
    // column content
    columnContentA={(
      <>
        <Typography nextElement='button'>
          For more than 30 years, we&#39;ve prioritized quality education for youth in our hometown of Milwaukee. As one of the city&#39;s largest employers, our investment of time and economic support improves opportunities for local students and builds a strong pipeline of future Milwaukee leaders and professionals to sustain our momentum and results.
        </Typography>
        <Link
          id='sustainability-impact-communities-building-education-link'
          variant='buttonLinkSecondary'
          linkUrl={`${nmFoundationBaseUrl}/education/`}
          ariaLabel='Find out more about how we are building education.'
          isInternalPdf>
          Find out more
        </Link>
      </>
    )}
    // image props
    imageAltText='Teacher helping children in classroom with computers'
    imageSrcDefault={buildingEducationImageDesktopWebp}
    imageSrcMobile={buildingEducationImageMobileWebp}
  />
);
